<template>
  <div class="message fc-blue" v-show="showMessage1">
    <!-- ------------------ -->
       <div class="loginBack" v-if="loginSt==1">
         <input type="text" style="position:absolute;top:10000000px">
      <div class="loginBox" v-if="progressSt == 1">
        <div class="lfBox">
        </div>
        <div class="rgBox">
          <img
            src="../../../static/images/close.png"
            alt=""
            class="close_img"
            @click="closeMethod"
          />
          <p class="loginTitle">欢迎登录</p>
          <div class="tabBox" :class="tabSt == 0 ? 'btn_act' : 'btn_act1'">
            <div
              class="tab_btn"
              :class="tabSt == 0 ? 'tab_act' : ''"
              @click="tabMethod(0)"
            >
              微信扫码登录
            </div>
            <div
              class="tab_btn"
              :class="tabSt == 1 ? 'tab_act' : ''"
              @click="tabMethod(1)"
            >
              账号密码登录
            </div>
          </div>
          <div class="codeBox" v-show="tabSt == 0">
            <img :src="imgCodeUrl" class="code_img" v-show="!qrcodeLoading" />
            <img
              src="../../../static/images/jzlerwm.gif"
              alt=""
              class="code_img1"
              v-show="qrcodeLoading"
            />
            <div @click="getQrcode">刷新二维码</div>
            <div class="remember">
              <input
                type="checkbox"
                oninput="value=value.replace(/[^\d]/g,'')"
                name=""
                v-model="remember"
              />
              <span class="mem_acc">自动登录</span>
            </div>
            <p class="code_text">请使用手机微信扫码登录或注册</p>
            <p class="qqlogin">
              <span @click="QQLoginClick()" class="qqspan">
                <img src="../../common/assets/QQ_login.png" alt="QQ登入" />
                <span class="qqtext">QQ登录</span>
              </span>
            </p>
          </div>
          <div class="rootBox" v-show="tabSt == 1">
            <div class="account">
              <img
                src="../../../static/images/account.png"
                alt=""
                class="account_img"
              />
              <input
                type="text"
                name=""
                class="account_inp"
                placeholder="请输入账号（注册时的手机号码）"
                v-model="username"
              />
            </div>
            <div class="password">
              <img
                src="../../../static/images/password.png"
                alt=""
                class="password_img"
              />
              <input
                type="password"
                name=""
                class="password_inp"
                placeholder="请输入密码"
                v-model="password"
              />
              <span class="forget_btn" @click="retrieveMethod">忘记密码</span>
            </div>
            <div class="memoryBox">
              <div class="lft">
                <input type="checkbox" name="" v-model="remember" />
                <span class="mem_acc">自动登录</span>
              </div>
              <p class="err" v-show="errText">{{ errText }}</p>
            </div>
            <div class="sign_btn" @click="clickLoginMethod">登录</div>
          </div>
        </div>
      </div>
      <div class="loginBox" v-if="progressSt == 2">
        <div class="lfBox">
          <img src="../../../static/images/head_logo.png" alt="" class="logo" />
          <p class="title">极致了数据</p>
        </div>
        <div class="rgBox">
          <div class="inpList">
            <div class="inpBox">
              <p class="tit">手机号码</p>
              <input
                type="text"
                placeholder="请输入手机号"
                class="inp"
                v-model="phone"
              />
            </div>
            <div class="inpBox">
              <p class="tit">验证码</p>
              <div class="yzmBox">
                <input
                  type="text"
                  placeholder="请输入短信验证码"
                  class="inp1"
                  v-model="code"
                />
               <p v-show="sendBtn==0"
                  class="hqyzm"
                  @click="sendCodeMethod"
                >
                  获取验证码
                </p>
                <p v-show="sendBtn==1"
                  class="hqyzm1"
                >
                  {{ yzmTx }}
                </p>
              </div>
            </div>
            <div class="inpBox">
              <p class="tit">设置新密码</p>
              <input
                type="password"
                placeholder="8-15位数字与字母组合"
                class="inp"
                v-model="password1"
              />
            </div>
            <div class="inpBox">
              <p class="tit">确认密码</p>
              <input
                type="password"
                placeholder="请确认登录密码"
                class="inp"
                v-model="confirm"
              />
            </div>
            <div class="completeBox3" @click="registerMethod" data-agl-cvt="5">
              完成
            </div>
            <span
              style="
                display: block;
                width: 100%;
                margin-top: 20px;
                margin-left: 5px;
                font-size: 20px;
                text-align: center;
                color: red;
              "
              >Api接口免费体验额度已到帐</span
            >
          </div>
        </div>
      </div>
      <div class="loginBox" v-if="progressSt == 3">
        <div class="lfBox"></div>
        <div class="rgBox">
          <img
            src="../../../static/images/close.png"
            alt=""
            class="close_img"
            @click="closeMethod"
          />
          <div class="stepBox">
            <el-steps :active="active" align-center finish-status="success">
              <el-step title="验证微信" description=""></el-step>
              <el-step title="设置新密码" description=""></el-step>
              <el-step title="完成更改" description=""></el-step>
            </el-steps>
          </div>
          <div v-show="active == 1">
            <p class="stepTx">验证微信账号</p>
            <img src="" alt="" class="wx_code" />
            <p class="code_tit">请使用注册的微信号扫一扫验证</p>
          </div>
          <div v-show="active == 2" class="inpList">
            <div class="inpBox">
              <p class="tit">手机号码</p>
              <input
                type="text"
                placeholder="请输入手机号"
                class="inp"
                v-model="phone"
              />
            </div>
            <div class="inpBox">
              <p class="tit">验证码</p>
              <div class="yzmBox">
                <input
                  type="text"
                  placeholder="请输入短信验证码"
                  class="inp1"
                  v-model="code"
                />
                <p
                  class="hqyzm"
                  @click="sendCodeMethod1"
                  :class="yzmTx !== '获取验证码' ? 'yzm_act' : ''"
                >
                  {{ yzmTx }}
                </p>
              </div>
            </div>
            <div class="inpBox">
              <p class="tit">设置新密码</p>
              <input
                type="password"
                placeholder="8-15位数字与字母组合"
                class="inp"
                v-model="password1"
              />
            </div>
            <div class="inpBox">
              <p class="tit">确认密码</p>
              <input
                type="password"
                placeholder="请确认登录密码"
                class="inp"
                v-model="confirm"
              />
            </div>
            <div class="completeBox3 qrBtn" @click="replaceMethod">确定</div>
          </div>
          <div v-show="active == 3">
            <img
              src="../../../static/images/modify.jpg"
              alt=""
              class="wx_code1"
            />
            <p class="code_tit1">修改成功</p>
          </div>
        </div>
      </div>
       <!-- // ----------提交用户信息---------- -->
    <div class="loginBox1" v-if="progressSt == 4">
        <div class="lfBox">
          <img src="../../../static/images/head_logo.png" alt="" class="logo" />
          <p class="title">极致了数据</p>
        </div>
        <div class="rgBox">
          <div class="head_tx">提交资料</div>
          <p class="head_p">请认真填写一下内容，以便及时为您提供后续服务</p>
          <img
          src="../../../static/images/close.png"
          alt=""
          class="close_img"
          @click="jumpsucc"
            />
          <div class="inpListk">
            <div class="user_d"><span>*</span>您的定位：</div>
            <div class="radio_box" @change="radioMethod(type)">
              <el-radio v-model="type" label="广告主">广告主</el-radio>
              <el-radio v-model="type" label="媒体机构">媒体机构</el-radio>
              <el-radio v-model="type" label="舆情机构">舆情机构</el-radio>
              <el-radio v-model="type" label="4A公司">4A公司</el-radio>
              <el-radio v-model="type" label="其他">其他</el-radio>
            </div>
            <div class="user_l">
              <div class="user_name">
                <p class="unp"><span style="color:red">*</span>联系人姓名：</p>
                <el-input
                type="text"
                placeholder="请填写您的姓名"
                class="inp"
                v-model="myname"
              />
              </div>
              <div class="user_name">
                <p class="unp"><span style="color:red">*</span>联系方式：</p>
                <el-input
                type="text"
                placeholder="请填写联系方式"
                class="inp"
                v-model="phone"
              />
              </div>
            </div>
            <div class="user_l">
              <div class="user_name">
                <p class="unp"><span style="color:red">*</span>公司名称：</p>
                <el-input
                type="text"
                placeholder="请填写所在公司名称"
                class="inp"
                v-model="company"
              />
              </div>
              <div class="user_name">
                <p class="unp"><span style="color:red">*</span>公司行业：</p>
                <el-input
                type="text"
                placeholder="请填写公司行业"
                class="inp"
                v-model="industry"
              />
              </div>
            </div>
            <div class="user_x">
              <p class="unp">您的需求是什么：</p>
              <el-input
                style="background: #fff;z-index: 100;"
                type="textarea"
                :rows="5"
                v-model="need"
                resize="none"
                class="textarea"
                maxlength="200"
                show-word-limit
                placeholder="请填写您的大致需求，两百字以内"
          ></el-input>
            </div>
            <div class="completeBox3" @click="registerMethod1">
              完成
            </div>
            <div class="completeBox6" @click="jumpsucc">
              跳过
            </div>
          </div>
                </div>
    </div>
    </div>
    <transition name="slide-fade">
      <div class="message-container" v-if="showMessage">
        <img src="../../../static/images/close.png" alt="" class="cloimg" @click="closeSelf()">
        <img
          src="../../../static/images/true.gif"
          class="close-img"
          v-show="type == 'success'"
        />
        <img
          :src="gt"
          class="close-img"
          v-show="type == 'warning' || type == 'warning1'"
        />
        <img :src="er" class="close-img" v-show="type == 'error'" />
        <div class="message-right">
          <div class="text" v-show="type != 'warning1'">{{ text }}</div>
          <div class="text1" v-show="type == 'warning1'">{{ text1 }}</div>
          <div v-show="tips && type == 'success'" class="tips">
            您可以在【<span style="color:#20A0FF;cursor:pointer;" @click="tonewrouter(tips.href)">{{ tips.leval }}</span
            >】中查看详情
          </div>
          <div v-show="tips && type == 'warning'" class="tips">24小时后 /
           <span style="color:#20A0FF;cursor:pointer;" @click="tonewrouter(tips.href)">{{ tips.leval }}</span
            >获取更多功能使用次数
          </div>
          <div class="btn-box" v-if="type != 'code'">
            <div class="btn-whi btn-xl" v-show="istrues=='updatavip'" @click="upvip()" v-html="hrefk">立即升级</div>
            <div class="btn-whi btn-xl" v-show="istrues=='loginss'" @click="closelogin()">注册登录</div>
            <div class="btn-whi btn-xl" v-show="istrues!='loginss'&&istrues!='updatavip'" @click="closeSelf()">确定</div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script src="https://cdn.staticfile.org/vue/2.2.2/vue.min.js"></script>
<script>
export default {
  data() {
    return {
      gt: require("../../../static/images/gt.gif") + "?" + Math.random(),
      er: require("../../../static/images/error.gif") + "?" + Math.random(),
      su: require("../../../static/images/true.gif") + "?" + Math.random(),
      text: "",
      text1: "",
      type: "",
      istrues:'',
      imgCodeUrl: undefined,
      qrcode: '',
      hrefk:'',
      tips: false,
      showBg: false,
      showMessage: false,
      showMessage1: false,
      showCancel: false,
      canfirmText: "",
      cancelText: "",
      leaves:'',
      loginSt:0,
      qrcodeLoading: true,
      loginshow1t:false,
      password:'',
      username:'',
      tabSt:0,
      errText: '',
      remember:'',
      progressSt:1,
      password1:'',
      confirm:'',
      yzmTx: '获取验证码',
      yzmNum: 60,
      phone:'',
      code: '',
      sendBtn: 0,
      accessToken: '',
      infoData: '',
      usertype:'',
      active: 2,
      myname:'',
      company:'',
      industry:'',
      need:'',
    };
  },
  created(){
     var info = JSON.parse(localStorage.getItem('userInfo'));
        if (info) {
            this.accessToken = info.accessToken;
        }
      this.getQrcode();
  },
  methods: {
    closeMethod() {
            this.loginSt = 0;
            this.loginSt1 = 0;
            this.progressSt = 0;
            this.active = 2;
            this.$emit('click-event', 0);
            clearTimeout(this.timeFun)
        },
    //更换密码
        replaceMethod() {
            var that = this;
            if (that.registerBtn) {
                return
            }
            that.registerBtn = 1;
            that.$http.axiosFun(that.$api.account.reset, {
                phone: that.phone,
                code: that.code,
                password: that.password1,
                confirm: that.confirm,
            }, function(res) {
                that.registerBtn = 0;
                if (res.msg == '密码修改成功') {
                    that.active = 3;
                    // that.timeMethod()
                } else {
                    that.$message.error(res.msg);
                }
            });
        },
     // ---------------用户信息提交--------------------
         radioMethod(e){
            console.log(e);
            this.usertype=e;
        },
        // 跳过
        jumpsucc(){
            this.loginSt1 = 0;
            this.loginSt = 0;
            this.progressSt = 0;
            this.showMessage = false;
             this.$confirm('注册成功！您的API体验额度已到账', '提示', {
                confirmButtonText: '前往查看',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$router.push({
                    path: '/interface',
                    query: {
                        actnav: 3
                    }
                })
                this.loginSt = 0;
                this.loginSt1 = 0;
                this.progressSt = 0;
            }).catch(() => {
                this.loginSt = 0;
                this.loginSt1 = 0;
                this.progressSt = 0;
                this.$message({
                    type: 'success',
                    message: '提交成功'
                });
            });
        },
        //用户信息提交
        registerMethod1() {
            var that = this;
            if (that.registerBtn) {
                return
            }
            if(that.usertype==''){
                that.$my_message.install({
                    type: 'error',
                    text: '请选择您的行业定位！',
                    // customClass:'mas',
                });
                return
            };
            if(that.myname==''){
                that.$my_message.install({
                    type: 'error',
                    text: '用户姓名不能为空！',
                });
                return
            };
            if(that.phone==''){
                that.$my_message.install({
                    type: 'error',
                    text:  '联系方式不能为空！',
                });
                return
            };
            if(that.company==''){
                that.$my_message.install({
                    type: 'error',
                    text: '公司名称不能为空！',
                });
                return
            };
            if(that.industry==''){
                that.$my_message.install({
                    type: 'error',
                    text: '公司所属行业不能为空！',
                });
                return
            };
            if(that.need==''){
                that.$my_message.install({
                    type: 'error',
                    text: '请填写您的大致需求，两百字以内！',
                });
                return
            };
            that.registerBtn = 1;
            that.$http.axiosFun(that.$api.account.register_collect, {
                need: that.need,
                // wxid: that.wxid,
                name: that.myname,
                user_type: that.usertype,
                phone: that.phone,
                // code: that.code,
                company: that.company,
                // position: that.position,
                industry: that.industry,
            }, function(res) {
                that.registerBtn = 0;
                if (res.code == 2000) {
                    that.progressSt = 0;
                    that.loginSt = 0;
                    that.showMessage = false;
                    that.$confirm('注册并提交成功！您的API体验额度已到账', '提示', {
                        confirmButtonText: '前往查看',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        that.$router.push({
                            path: '/interface',
                            query: {
                                actnav: 3
                            }
                        })
                    }).catch(() => {
                        that.loginSt1 = 0;
                        that.progressSt = 0;
                        that.$message({
                            type: 'success',
                            message: '提交成功'
                        });
                    });;
                    // that.timeMethod()
                } else if (res.error_code == 30000) {
                    // that.progressSt = 4;
                    that.$message({
                        message: res.msg,
                        type: 'error'
                    });
                } else if (res.error_code == 30008) {
                    // that.progressSt = 2
                    that.$message({
                        message: res.msg,
                        type: 'error'
                    });
                }
            });
        },
        // ---------------------------------------
    tonewrouter(url){
        window.open(url,'_blank');
        this.showMessage1 = false;
    },
    retrieveMethod() {
            this.progressSt = s3
        },
    tabMethod(e) {
            this.tabSt = e
        },
     // QQ 登入
    QQLoginClick() {
        let that = this;
        that.$http.axiosFun(
        that.$api.account.QQLogin,
        {
        next: "https://www.jzl.com/",
        },
        function (res) {
            if (res.status == 200) {
            window.open(res.login_url, "_blank");
            }
        },
        {
            "Content-Type": "application/x-www-form-urlencoded",
            accessToken: that.accessToken,
        }
        );
    },
     // 获取微信二维码
        getQrcode() {
          var that = this;
            that.qrcodeLoading = true;
            that.$http.axiosFun(that.$api.account.qrcode, {}, function(res) {
                if (res.msg == 'success') {
                    that.qrcode = res.data.qrcode;
                    that.imgCodeUrl = res.data.img;
                    if (res.data.img == '') {
                        that.qrcodeLoading = true;
                    } else {
                        that.qrcodeLoading = false;
                    }
                }
            }, { 'Content-Type': 'multipart/form-data' });
        },
      loginHandler() {
            var that = this;
                var ajax = new XMLHttpRequest();
                ajax.open("post", that.$api.account.login.url);

        ajax.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
                ajax.send('token=' + that.qrcode + '&verifyCode=' + null + '&is_remember=' + that.isCheck);
                ajax.onreadystatechange = function() {
                    // 这步为判断服务器是否正确响应
                    if (ajax.readyState == 4 && ajax.status == 200) {
                        var res = JSON.parse(ajax.responseText);
                        if (res.msg == 'success') {
                            that.infoData = res.data;
                            if (res.data.type == 0) {
                                that.progressSt = 2;
                                //  that.$router.push({ path: '/wxregest',query:{infoData:JSON.stringify(res.data)} });
                            } else {
                                that.loginSt = 0;
                                that.accessToken = res.data.accessToken;
                                that.name = res.data.name;
                                that.loginType = 1;
                                that.avatar = res.data.avatar;
                                var userInfo = {
                                    accessToken: res.data.accessToken,
                                    name: res.data.name,
                                    loginType: 1,
                                    avatar: res.data.avatar
                                };
                                localStorage.setItem('userInfo', JSON.stringify(userInfo));
                            }
                            clearInterval(that.timeFun);
                            if (res.data.type != 0) {
                               location.reload();
                                that.showMessage = false;
                                that.showMessage1 = false;
                            }
                        }
                    }
                };
        },
     loginStMethod() {
            this.loginSt = 1;
        },
    // 去登录
    closelogin(){
      this.username='';
      this.password='';
      this.showMessage = false;
      this.loginshow1t = true;
      this.loginSt = true;
      this.progressSt=1;
      this.getQrcode();
      this.timeFun = setInterval(this.loginHandler, 2000);
    },
    // 去升级
    upvip(){
       this.showMessage = false;
      this.showMessage1 = false;
    },
    close() {
      this.showMessage = false;
      if (this.callback) {
        this.callback();
      }
    },
    closeCancel() {
      this.showMessage = false;
      if (this.cancelCallback) {
        this.cancelCallback();
      }
    },
    closeSelf() {
      this.showMessage = false;
      this.showMessage1 = false;
       clearTimeout(this.timeFun);
    },
    codeFn(e) {
      if (this.type == "code") {
        if (event.target.nodeName == "SPAN" && this.codeCallback) {
          this.codeCallback();
        }
      }
    },
    // -----------------------
     tabMethod(e){
      this.tabSt=e
    },
    openMethod(){
      var that=this;
      that.loginSt=1;
      that.getQrcode();
      if(!that.loginType){
        that.timeFun=setInterval(that.loginHandler,2000)
      }
    },
    closeMethod(){
      this.loginSt=0;
      this.progressSt=1;
      this.active=2;
      this.showMessage1 = false;
    },
    mouseMethod(e){
      this.outAct=e;
    },
    mouseMethod1(e){
      this.outLogin=e;
    },
    jumpCenter(){
      this.$router.push({
        path: '/center',
      })
    },
    recordMethod(){
      var that=this;
      that.$http.axiosFun(that.$api.search.search_record, null, function (res) {
        if (res.msg=='用户未登录') {
          that.accessToken='';
          localStorage.removeItem('userInfo')
        }
      },{'Content-Type': 'application/x-www-form-urlencoded','accessToken':that.accessToken});
    },
    jumpCurrent(){
      this.$router.push({
        path: '/currentVip',
      })
    },
    //获取验证码..
    sendCodeMethod() {
            var that = this;
            if (!that.phone) {
                that.$message({
                    type: 'error',
                    message: '手机号不能为空！',
                    // customClass:'mas',
                });
                return
            }
            if (that.phone.length !== 11) {
                that.$message({
                    type: 'error',
                    message: '请输入正确的手机号!',
                    // customClass:'mas',
                });
                return
            }
            if (that.sendBtn) {
                return
            }
            that.sendBtn = 1;
            that.yzmTx = '发送中...';
            that.$http.axiosFun(that.$api.account.sendCode, {
                phone: that.phone
            }, function(res) {
                if (res.msg == '验证码已发送') {
                    that.timeMethod()
                } else {
                    that.$message({
                        message: res.msg,
                        type: 'warning'
                    });
                    that.sendBtn = 0;
                }
            });
        },
    //忘记密码获取验证码..
    sendCodeMethod1(){
      var that=this;
      if(that.sendBtn){
        return
      }
      if (!that.phone) {
                that.$message({
                    type: 'error',
                    message: '手机号不能为空！',
                    // customClass:'mas',
                });
                return
            }
            if (that.phone.length !== 11) {
                that.$message({
                    type: 'error',
                    message: '请输入正确的手机号!',
                    // customClass:'mas',
                });
                return
            }
      that.sendBtn=1;
      that.$http.axiosFun(that.$api.account.sendCode, {
        phone: that.phone
      }, function (res) {
        if (res.msg=='验证码已发送') {
          that.timeMethod()
        }else {
          that.$message({
            message: res.msg,
            type: 'warning'
          });
        }
      },{'Content-Type': 'application/json'});
    },
     // 注册
        registerMethod() {
            var that = this;
            if (that.registerBtn) {
                return
            };
            if(that.phone==''){
                that.$message({
                    type: 'error',
                    message: '手机号不能为空！',
                    // customClass:'mas',
                });
                return
            };
            if(that.code==''){
                that.$message({
                    type: 'error',
                    message:  '请输入验证码！',
                });
                return
            };
            if(that.password1.length<=7){
                that.$message({
                    type: 'error',
                    message: '密码长度不得小于8位！',
                    // customClass:'mas',
                });
                return
            };
            if(that.password1!=that.confirm){
                that.$message({
                    type: 'error',
                    message: '两次密码输入不一致！',
                    // customClass:'mas',
                });
                return
            }
            that.registerBtn = 1;
            that.$http.axiosFun(that.$api.account.register, {
                username: that.infoData.name,
                phone: that.phone,
                accessToken: that.infoData.accessToken,
                code: that.code,
                password: that.password1,
                confirm: that.confirm,
                invitecode: that.invitecode,
            }, function(res) {
                that.massageshow = false;
                that.registerBtn = 0;
                if (res.error_code == 0) {
                    // that.loginSt = 0;
                    that.progressSt = 4;
                    that.accessToken = that.infoData.accessToken;
                    that.name = that.infoData.name;
                    that.loginType = 1;
                    that.avatar = that.infoData.avatar;
                    var userInfo = {
                        accessToken: that.infoData.accessToken,
                        name: that.infoData.name,
                        loginType: 1,
                        avatar: that.infoData.avatar
                    };
                    localStorage.setItem('userInfo', JSON.stringify(userInfo));
                    // that.$confirm('注册成功！您的API体验额度已到账', '提示', {
                    //     confirmButtonText: '前往查看',
                    //     cancelButtonText: '取消',
                    //     type: 'warning'
                    // }).then(() => {
                    //     that.$router.push({
                    //         path: '/interface',
                    //         query: {
                    //             actnav: 3
                    //         }
                    //     })
                    // }).catch(() => {
                    //     that.$message({
                    //         type: 'success',
                    //         message: '提交成功'
                    //     });
                    // });
            } else if (res.error_code == 30000) {
                    that.progressSt = 2
                    that.$message({
                        message: res.msg,
                        type: 'error'
                    });
                } else if (res.error_code == 30008) {
                    that.progressSt = 2
                    that.$message({
                        message: res.msg,
                        type: 'error'
                    });
                }else if (res.error_code == 30009) {
                    that.progressSt = 2
                    that.$message({
                        message: res.msg,
                        type: 'error'
                    });
                }
            });
        },
    //忘记密码
    retrieveMethod(){
      this.progressSt=3
    },
    timeMethod(){
      var that=this;
      setTimeout(function () {
        that.yzmNum--;
        that.yzmTx=that.yzmNum+'S';
        if (that.yzmNum>0){
          that.timeMethod();
        } else {
          that.yzmTx='获取验证码';
          that.yzmNum=60;
          that.sendBtn=0;
        }
      },1000)

    },
    // 获取微信二维码
    getQrcode(){
      var that=this;
      that.$http.axiosFun(that.$api.account.qrcode,{
      }, function (res) {
        if(res.msg=='success') {
          that.qrcode = res.data.qrcode;
          that.imgCodeUrl = res.data.img;
          that.qrcodeLoading = false;
        }
      },{'Content-Type': 'multipart/form-data'});
    },
    outMethod(){
      var that=this;
      that.$http.axiosFun(that.$api.user.login_out, {
      }, function (res) {
        if (res.msg=='退出成功') {
          that.accessToken='';
          that.avatar='';
          that.name='';
          that.loginType='';
          that.loginSt=0;
          that.progressSt=1;
          that.qrcode='';
          that.active=2;
          localStorage.removeItem('userInfo');
        }
      },{'Content-Type': 'application/x-www-form-urlencoded','accessToken':that.accessToken});
    },
    clickLoginMethod(event) {
            var ss = localStorage.getItem('locationsearch');
            console.log(ss);
            var that = this;
            if (that.btnSt) {
                return
            }
            that.btnSt = 1;
            if (that.remember) {
                that.isCheck = 1
            };
            var ajax = new XMLHttpRequest();
            ajax.open("post", that.$api.account.login.url);

      ajax.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
            ajax.send('token=' + that.qrcode + '&username=' + that.username + '&password=' + that.password + '&is_remember=' + that.isCheck + '&bd_vid=' + ss);
            ajax.onreadystatechange = function() {
                // 这步为判断服务器是否正确响应
                if (ajax.readyState == 4 && ajax.status == 200) {
                    var res = JSON.parse(ajax.responseText);
                    that.btnSt = 0;
                    if (res.msg == 'success') {
                        that.accessToken = res.data.accessToken;
                        that.name = res.data.name;
                        that.loginType = 1;
                        that.loginSt = 0;
                        var userInfo = {
                            accessToken: res.data.accessToken,
                            name: res.data.name,
                            loginType: 1,
                            avatar: res.data.avatar
                        }
                        localStorage.setItem('userInfo', JSON.stringify(userInfo));
                        that.$emit('bffLogin')
                        clearInterval(that.timeFun);
                        location.reload();
                    } else {
                        that.$message.error(res.msg);
                    }
                }
            };
        },
    regHandler(){
      var that=this;
      that.$http.axiosFun(that.$api.account.register, {
        token: 'f282de108943a5739e340542ccd29ac0',
        verifyCode: '',
        is_remember: 0,
      }, function (res) {
      });
    },
    outHandler(){
      // var that=this;
      // that.axios.get('/user/v1/login_out').then(res=>{
      //   console.log(res);
      //   }
      // )
    }
  }

};
</script>
<style lang="less" scoped>
/deep/ .el-radio{
  margin-right: 18px !important;
  font-family:'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif; ;
  font-weight: 500;
}
.mas{
  left:56%;
  top:50% !important;
  margin-top: -345px !important;
  color: #fff !important;
}
</style>
<style scoped lang="less">
.slide-fade-enter-active {
  animation: all 0.3s;
}
.bounce-leave-active {
  animation: bounce-in 0.3s reverse;
}
@keyframes all {
  0% {
    transform: scale(0);
  }
  10% {
    transform: scale(0.3);
  }
  20% {
    transform: scale(0.45);
  }
  30% {
    transform: scale(0.6);
  }
  40% {
    transform: scale(0.75);
  }
  50% {
    transform: scale(0.9);
  }
  60% {
    transform: scale(1.1);
  }
  70% {
    transform: scale(1.3);
  }
  80% {
    transform: scale(1.2);
  }
  90% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}
.message {
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0);
  z-index: 100001;
  // -------------
   .loginBox{
      width: 420px;
      height: 500px;
      border-radius: 10px;
      overflow: hidden;
      background: white;
      position: fixed;
      z-index: 99999;
      box-shadow: 0px 0px 9px 1px rgba(8, 8, 8, 0.2);
      top: -130px;
      left: 220px;
      right: 0;
      bottom: 0;
      margin: auto;
      display: flex;
      .close_img{
        position: absolute;
        right: 10px;
        top: 10px;
        height: 20px;
      }
      .lfBox{
        width: 200px;
        height: 690px;
        background: #A2DBFF;
        .logo{
          width: 80px;
          height: 80px;
          margin-top: 287px;
          margin-left: 60px;
        }
        .title{
          font-size: 16px;
          margin-top: 20px;
          color: #FFFFFF;
          text-align: center;
        }
      }
      .rgBox{
        flex: 1;
        .close_img{
          width: 15px;
          height: 15px;
          position: absolute;
          top: 15px;
          right: 15px;
        }
        .loginTitle{
          width: 100%;
          text-align: center;
          font-size: 22px;
          font-weight: bold;
          margin-top: 20px;
        }
        .loginTitle_act{
          padding-bottom: 80px;
          border-bottom: 3px solid #F2F5F9;
        }
        .tabBox{
          display: flex;
          margin-top: 20px;
          border-bottom: 3px solid #F2F5F9;
          position: relative;
          .tab_btn{
            width: 50%;
            height: 40px;
            text-align: center;
            font-size: 16px;
            color: #999999;
          }
          .tab_btn1{
            width: 100%;
            height: 40px;
            text-align: center;
            font-size: 20px;
            color: #252525;
          }
          .tab_act{
            font-weight: bold;
            color: #333333;
            font-size: 20px;
          }
        }
        .btn_act:after{
          content: '';
          display: inline-block;
          width: 76px;
          height: 3px;
          background: #20A0FF;
          text-align: center;
          position: absolute;
          bottom: 0;
          left: 19%;
          transition: 0.5s;
        }
        .btn_act1:after{
          content: '';
          display: inline-block;
          width: 80px;
          height: 3px;
          background: #20A0FF;
          text-align: center;
          position: absolute;
          bottom: 0;
          left: 69%;
          transition: 0.5s;
        }
        .codeBox{
          margin-top: 30px;
          text-align: center;
          .blue{
            color: #20A0FF;
          }
          .code_img{
            width: 200px;
            height: 200px;
          }
          .code_img1{
            width: 200px;
            height: 200px;
          }
          .remember{
            width: 200px;
            text-align: center;
            margin: auto;
            margin-top: 20px;
          }
          .code_text{
            font-size: 18px;
            color: #657D97;
            margin-top: 20px;
          }
          .qqlogin{
            width: 100%;
            height:50px;
            margin-top: 20px;
            .qqspan{
              width: 35%;
              height:50px;
              display: block;
              margin-left: calc(100% / 2 - 48px);
              img{
                width: 40px;
                height:40px;
                display: block;
                float: left;
              }
              .qqtext{
                display: block;
                float: left;
                font-size: 20px;
                height:40px;
                color:#333;
                line-height: 40px;
                font-family: "微软雅黑";
                font-weight: bold;
                margin-left: 10px;
              }
            }
          }
        }
        .codeBox1{
          margin-top: 60px;
          text-align: center;
          .blue{
            color: #20A0FF;
          }
          .code_img3{
            width: 300px;
            height: 300px;
          }
          .code_img4{
            width: 300px;
            height: 300px;
          }
          .code_text{
            font-size: 18px;
            color: #657D97;
            margin-top: 40px;
          }
        }
        .rootBox{
          margin-top: 50px;
          .account{
            width: 350px;
            height: 50px;
            border-radius: 5px;
            border: 2px solid #999999;
            margin: auto;
            display: flex;
            align-items: center;
            .account_img{
              width: 28px;
              height: 30px;
              margin: 0 12px;
            }
            .account_inp{
              border: none;
              outline: none;
              height: 40px;
              flex: 1;
            }
            .account_inp::placeholder{
              font-size: 12px;
              color: #999999;
            }
          }
          .password{
            width: 350px;
            height: 50px;
            border-radius: 5px;
            border: 2px solid #999999;
            margin: auto;
            display: flex;
            align-items: center;
            margin-top: 30px;
            .password_img{
              width: 28px;
              height: 30px;
              margin: 0 12px;
            }
            .password_inp{
              border: none;
              outline: none;
              height: 40px;
              width: 200px;
              margin-right: 10px;
            }
            .password_inp::placeholder{
              font-size: 12px;
              color: #999999;
            }
            .forget_btn{
              font-size: 16px;
              color: #666666;
              text-decoration: underline;
              cursor:pointer;
            }
          }
          .memoryBox{
            width: 350px;
            display: flex;
            justify-content: space-between;
            margin: auto;
            margin-top: 15px;
            .lft{
              display: flex;
              //align-items: center;
              .mem_acc{
                margin-left: 5px;
              }
            }
            .err{
              color: red;
            }
          }
          .sign_btn{
            background: #20A0FF;
            width: 350px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            color: #FFFFFF;
            border-radius: 5px;
            box-shadow: 0px 0px 9px 1px rgba(32, 160, 255, 0.2);
            margin: 30px auto;
          }
        }
        .skip{
          text-align: right;
          margin-right: 30px;
          margin-top: 30px;
          font-size: 14px;
          color: #20A0FF;
        }
        .inpList{
          width: 350px;
          margin: auto;
          margin-top: 60px;
          .inpBox{
            margin-top: 10px;
            .tit{
              color: #333333;
              font-size: 18px;
              font-weight: bold;
              margin-top: 13px;
            }
            .inp{
              margin-top: 16px;
              width: 100%;
              height: 36px;
              padding-left: 12px;
              border-radius: 6px;
              border: 1px solid #E5E5E5;
              outline: none;
            }
            .yzmBox{
              width: 100%;
              display: flex;
              align-items: center;
              height: 40px;
              border: 1px solid #E5E5E5;
              padding-left: 12px;
              border-radius: 6px;
              .inp1{
                width: 230px;
                height: 28px;
                border: none;
                outline: none;

              }
              .hqyzm{
                width: 110px;
                height: 28px;
                background: #20A0FF;
                color: #FFFFFF;
                text-align: center;
                line-height: 28px;
                font-size: 12px;
                border-radius: 5px;
                cursor:pointer;
              }
              .hqyzm1{
                width: 110px;
                height: 28px;
                background: #20A0FF;
                color: #FFFFFF;
                text-align: center;
                line-height: 28px;
                font-size: 12px;
                border-radius: 5px;
                cursor:pointer;
                background: #CCCCCC;

              }
              .yzm_act{
                background: #CCCCCC;

              }
            }
          }
          .completeBox3{
            width: 366px;
            height: 40px;
            margin-top: 30px;
            background: #3a8ee6;
            color: #FFFFFF;
            text-align: center;
            line-height: 40px;
            border-radius: 5px;
          }
          .qrBtn{
            background: #32F14B;
            box-shadow: 0px 0px 9px 1px rgba(50, 241, 75, 0.2);
          }
        }
        .stepBox{
          width: 450px;
          //height: 120px;
          padding: 20px 0;
          background: #F5F5F5;
          border-radius: 5px;
          margin: auto;
          margin-top: 60px;
          .is-text{
            width: 50px !important;
            height: 50px !important;
          }
        }
        .stepTx{
          font-size: 14px;
          font-weight: bold;
          text-align: center;
          margin: 40px 0;
        }
        .wx_code{
          width: 200px;
          height: 200px;
          display: block;
          margin: auto;
        }
        .wx_code1{
          width: 200px;
          height: 200px;
          display: block;
          margin: auto;
          margin-top: 120px;
        }
        .code_tit{
          color: #657D97;
          font-size: 20px;
          text-align: center;
          margin-top: 15px;
        }
        .code_tit1{
          font-size: 20px;
          text-align: center;
          margin-top: 60px;
        }
        .gobtn{
          width: 350px;
          height: 60px;
          border: 2px solid #D2D2D2;
          text-align: center;
          line-height: 62px;
          color: #999999;
          font-size: 18px;
          margin: auto;
          margin-top: 60px;
          border-radius: 5px;

        }
      }
    }
     .loginBack{
    width: 100vw;
    height: 100vh;
    background: rgba(0,0,0,0.5);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 900000;
    cursor:pointer;
    .loginBox{
      width: 820px;
      height: 690px;
      cursor:pointer;
      border-radius: 10px;
      overflow: hidden;
      background: white;
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      display: flex;
      .lfBox{
        width: 200px;
        height: 690px;
        background: #A2DBFF;
        .logo{
          width: 80px;
          height: 80px;
          margin-top: 287px;
          margin-left: 60px;
        }
        .title{
          font-size: 16px;
          margin-top: 20px;
          color: #FFFFFF;
          text-align: center;
        }
      }
      .rgBox{
        flex: 1;
        .close_img{
          width: 24px;
          height: 24px;
          position: absolute;
          top: 30px;
          right: 30px;
        }
        .loginTitle{
          width: 100%;
          text-align: center;
          font-size: 26px;
          font-weight: bold;
          margin-top: 60px;
        }
        .tabBox{
          display: flex;
          margin-top: 30px;
          border-bottom: 3px solid #F2F5F9;
          position: relative;
          .tab_btn{
            width: 50%;
            height: 40px;
            text-align: center;
            font-size: 16px;
            color: #999999;
          }
          .tab_act{
            font-weight: bold;
            color: #333333;
            font-size: 20px;
          }
        }
        .btn_act:after{
          content: '';
          display: inline-block;
          width: 76px;
          height: 3px;
          background: #20A0FF;
          text-align: center;
          position: absolute;
          bottom: 0;
          left: 19%;
          transition: 0.5s;
        }
        .btn_act1:after{
          content: '';
          display: inline-block;
          width: 80px;
          height: 3px;
          background: #20A0FF;
          text-align: center;
          position: absolute;
          bottom: 0;
          left: 69%;
          transition: 0.5s;
        }
        .codeBox{
          margin-top: 100px;
          text-align: center;
          .code_img{
            width: 200px;
            height: 200px;
          }
          .remember{
            width: 200px;
            text-align: center;
            margin: auto;
            margin-top: 20px;
          }
          .code_text{
            font-size: 16px;
            color: #657D97;
            margin-top: 40px;
          }
        }
        .rootBox{
          margin-top: 50px;
          .account{
            width: 350px;
            height: 50px;
            border-radius: 5px;
            border: 2px solid #999999;
            margin: auto;
            display: flex;
            align-items: center;
            .account_img{
              width: 28px;
              height: 30px;
              margin: 0 12px;
            }
            .account_inp{
              border: none;
              outline: none;
              height: 40px;
              flex: 1;
            }
            .account_inp::placeholder{
              font-size: 12px;
              color: #999999;
            }
          }
          .password{
            width: 350px;
            height: 50px;
            border-radius: 5px;
            border: 2px solid #999999;
            margin: auto;
            display: flex;
            align-items: center;
            margin-top: 30px;
            .password_img{
              width: 28px;
              height: 30px;
              margin: 0 12px;
            }
            .password_inp{
              border: none;
              outline: none;
              height: 40px;
              width: 200px;
              margin-right: 10px;
            }
            .password_inp::placeholder{
              font-size: 12px;
              color: #999999;
            }
            .forget_btn{
              font-size: 16px;
              color: #666666;
              text-decoration: underline;
              cursor:pointer;
            }
          }
          .memoryBox{
            width: 350px;
            display: flex;
            justify-content: space-between;
            margin: auto;
            margin-top: 15px;
            .lft{
              display: flex;
              //align-items: center;
              .mem_acc{
                margin-left: 5px;
              }
            }
            .err{
              color: red;
            }
          }
          .sign_btn{
            background: #20A0FF;
            width: 350px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            color: #FFFFFF;
            border-radius: 5px;
            box-shadow: 0px 0px 9px 1px rgba(32, 160, 255, 0.2);
            margin: 30px auto;
          }
        }
        .skip{
          text-align: right;
          margin-right: 30px;
          margin-top: 30px;
          font-size: 14px;
          color: #20A0FF;
        }
        .inpList{
          width: 350px;
          margin: auto;
          margin-top: 60px;
          .inpBox{
            margin-top: 10px;
            .tit{
              color: #333333;
              font-size: 18px;
              font-weight: bold;
              margin-top: 13px;
            }
            .inp{
              margin-top: 16px;
              width: 100%;
              height: 36px;
              padding-left: 12px;
              border-radius: 6px;
              border: 1px solid #E5E5E5;
              outline: none;
            }
            .yzmBox{
              width: 100%;
              display: flex;
              align-items: center;
              height: 40px;
              border: 1px solid #E5E5E5;
              padding-left: 12px;
              border-radius: 6px;
              .inp1{
                width: 230px;
                height: 28px;
                border: none;
                outline: none;

              }
              .hqyzm{
                width: 110px;
                height: 28px;
                background: #20A0FF;
                color: #FFFFFF;
                text-align: center;
                line-height: 28px;
                font-size: 12px;
                border-radius: 5px;
                cursor:pointer;
              }
              .yzm_act{
                background: #CCCCCC;

              }
            }
          }
          .completeBox{
            width: 366px;
            height: 40px;
            margin-top: 30px;
            background: #3a8ee6;
            color: #FFFFFF;
            text-align: center;
            line-height: 40px;
            border-radius: 5px;
          }
          .qrBtn{
            background: #32F14B;
            box-shadow: 0px 0px 9px 1px rgba(50, 241, 75, 0.2);
          }
        }
        .stepBox{
          width: 450px;
          //height: 120px;
          padding: 20px 0;
          background: #F5F5F5;
          border-radius: 5px;
          margin: auto;
          margin-top: 60px;
          .is-text{
            width: 50px !important;
            height: 50px !important;
          }
        }
        .stepTx{
          font-size: 14px;
          font-weight: bold;
          text-align: center;
          margin: 40px 0;
        }
        .wx_code{
          width: 200px;
          height: 200px;
          display: block;
          margin: auto;
        }
        .wx_code1{
          width: 200px;
          height: 200px;
          display: block;
          margin: auto;
          margin-top: 120px;
        }
        .code_tit{
          color: #657D97;
          font-size: 20px;
          text-align: center;
          margin-top: 15px;
        }
        .code_tit1{
          font-size: 20px;
          text-align: center;
          margin-top: 60px;
        }
      }
    }
    // ----------提交用户信息----------
     .loginBox1{
      width: 820px;
      height: 690px;
      border-radius: 10px;
      overflow: hidden;
      background: white;
      position: fixed;
      z-index: 99999;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      display: flex;
      .close_img{
        position: absolute;
        right: 10px;
        top: 10px;
        height: 20px;
      }
      .lfBox{
        width: 200px;
        height: 690px;
        background: #A2DBFF;
        .logo{
          width: 80px;
          height: 80px;
          margin-top: 287px;
          margin-left: 60px;
        }
        .title{
          font-size: 16px;
          margin-top: 20px;
          color: #FFFFFF;
          text-align: center;
        }
      }
      .rgBox{
        flex: 1;
        .head_tx{
          width: 100%;
          font-size: 30px;
          font-family: Source Han Sans CN-Regular, Source Han Sans CN;
          font-weight: 500;
          color: #20A0FF;
          text-align: center;
          margin-top: 20px;
        }
        .head_p{
          width: 100%;
          text-align: center;
          font-size: 20px;
          font-family: Source Han Sans CN-Regular, Source Han Sans CN;
          font-weight: 500;
          color: #999999;
          line-height: 46px;
        }
        .close_img{
          width: 24px;
          height: 24px;
          position: absolute;
          top: 20px;
          right: 30px;
        }
        .inpListk{
          width: 85%;
          margin: 0 auto;
          .user_d{
            font-size: 18px;
            font-family: Source Han Sans CN-Regular, Source Han Sans CN;
            font-weight: 600;
            color: #2C2C2C;
            line-height: 30px;
            span{
              font-size: 18px;
              margin-right: 5px;
              color: red;
            }
          }
          .radio_box{
            font-size: 20px;
            font-family: Source Han Sans CN-Regular, Source Han Sans CN;
            font-weight: 500;
          }
          .user_l{
            width: 95%;
            margin: 20px auto;
            display: flex;
            justify-content: space-between;
           .user_name{
              width: 49%;
             .unp{
              font-size: 18px;
              font-family: Source Han Sans CN-Regular, Source Han Sans CN;
              font-weight: 600;
              margin-bottom: 10px;
             }
             .inp{
               width: 90%;
               display: block;
             }
           }
          }
          .user_x{
            width: 95%;
            margin: 0 auto;
            .unp{
              font-size: 18px;
              font-family: Source Han Sans CN-Regular, Source Han Sans CN;
              font-weight: 600;
              margin-bottom: 10px;
             }
          }
          .completeBox3{
            width: 260px;
            height: 40px;
            margin: 0 auto;
            margin-top: 25px;
            background: #3a8ee6;
            color: #FFFFFF;
            text-align: center;
            line-height: 40px;
            border-radius: 5px;
            cursor: pointer;
          }
          .completeBox6{
            width: 200px;
            height: 40px;
            margin: 0 auto;
            margin-top: 25px;
            background: #fb4d02;
            color: #FFFFFF;
            text-align: center;
            line-height: 40px;
            border-radius: 5px;
            cursor: pointer;
          }
        }
      }
    }
    // --------------------------
  }
}
.message-container {
  width: 443px;
  /* height:260px; */
  height: auto;
  position: absolute;
  top: 25%;
  left: 45%;
  z-index: 100000;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 0 6px 8px #f5f5f5;
  border: 3px solid rgb(228, 228, 228);
  .cloimg{
    width: 15px;
    height:15px;
    position: absolute;
    top:10px;
    right:10px;
    opacity: 0.7;
  }
}
.close-img {
  width: 90px;
  height: 90px;
  display: block;
  margin: 30px auto;
}
.tips {
  width: 100%;
  height: 30px;
  margin-top: 10px;
  text-align: center;
  line-height: 30px;
  display: inline-block;
  >a {
    text-decoration: none;
    color: #20a0ff;
  }
}
.btn-xl {
  width: 80px;
  height: 40px;
  padding: 0px 15px;
  background: #20a0ff;
  text-align: center;
  line-height: 40px;
  color: #fff;
  margin: 20px auto;
  font-size: 20px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 500;
  border-radius: 5px;
  cursor: pointer;
}
.text {
  margin: 0 auto;
  padding: 0 15px;
  font-size: 22px;
  font-family: "微软雅黑";
  font-weight: 500;
  color: rgb(49, 49, 49);
  text-align: center;
  line-height: 25px;
}
.text1 {
  margin: 0 auto;
  padding: 0 15px;
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 500;
  color: rgb(44, 44, 44);
  text-align: center;
  line-height: 23px;
}
</style>



// WEBPACK FOOTER //
// src/components/message/message.vue